import React from 'react'
import SimpleSpinner from "../Loader/SimpleSpinner";
export default function ProgressLoading() {
    return (
        <div className='default-loader'>
            <SimpleSpinner topCenter/>
        </div>
    )
}
